import en from './en.json';
import fr from './fr.json';
import de from './de.json';
import lu from './lu.json';
import ru from './ru.json';
import el from './el.json';

/**
 * Локали b2b-demo и резолв ключа — вне React (#1440), чтобы и `I18nProvider`,
 * и компоненты, живущие без провайдера (формы виджета), переводили одинаково.
 * Источник JSON — `apps/b2b-ui/src/assets/i18n/*.json` (см. `I18nContext.jsx`).
 */
export const LOCALES = { en, fr, de, lu, ru, el };

/**
 * Resolve key из namespace в указанном языке. Поддерживаются вложенные ключи
 * через точку: `t('salon.cta.viewAll')`.
 */
const resolveKey = (locale, key) => {
  if (!locale) return undefined;
  const parts = key.split('.');
  let cur = locale;
  for (const part of parts) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[part];
  }
  return typeof cur === 'string' ? cur : undefined;
};

/**
 * Перевод с fallback-цепочкой `t()`: lang → fr → en. Нет ключа — `undefined`
 * (что показать вместо — решает вызывающий: `t()` показывает ключ/fallback).
 */
export const translate = (language, key) =>
  resolveKey(LOCALES[language], key)
  ?? resolveKey(LOCALES.fr, key)
  ?? resolveKey(LOCALES.en, key);
